import React from 'react';
import {injectIntl} from 'react-intl';

const ConfirmationBanner = ({intl, buttonURL, imgSrc, description}) => {
  return (
    <>
      <div className="banner banner-confirm">
        <div className="wrapper l:flex justify-between items-center">
          <div className="banner-confirm__media order-1 flex justify-center">
            <img src={imgSrc} width="350px" alt={intl.formatMessage({id: 'ConfirmationBanner.ImageAltText'})}/>
          </div>
          <div className="banner__content content-block">
            <h2 className="content-block__title">
              {intl.formatMessage({id: 'ConfirmationBanner.Title'})}
            </h2>
            <p className="content-block__description body-copy">
              {description}
            </p>
            <a href={buttonURL}
              className="button button--m">
              <span className="button__text">{intl.formatMessage({id: 'ConfirmationBanner.ButtonText'})}</span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(ConfirmationBanner);
